import { Card } from "@mui/material";

import CardHeader from "./CardHeader";
import Context from "./context";
import DeleteRedirectDialog from "./DeleteRedirectDialog/DeleteRedirectDialog";
import useRedirectCardActionsStore from "./store";
import RedirectsTable from "./Table/RedirectsTable";

// ----------------------------------------------------------------------

export const RedirectsCard = () => {
	const [state, actions] = useRedirectCardActionsStore();

	return (
		<Context.Provider value={{ actions, state }}>
			<Card sx={{ maxWidth: 1200, pb: 3 }}>
				<CardHeader />
				<RedirectsTable />
				<DeleteRedirectDialog />
			</Card>
		</Context.Provider>
	);
};

export default RedirectsCard;
